import { useQuery as useRQuery } from "react-query";

import type {
  QueryFunction,
  BaseQueryKey,
  UseBaseQueryOptions,
  UseBaseQueryResult,
} from "./types";

export function useBaseQuery<
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends BaseQueryKey = BaseQueryKey,
>(
  queryKey: TQueryKey,
  queryFn: QueryFunction<TQueryFnData, TQueryKey>,
  options?: Omit<
    UseBaseQueryOptions<TQueryFnData, TError, TData>,
    "queryKey" | "queryFn"
  >,
): UseBaseQueryResult<TData, TError> {
  const refetchInterval = options?.refetchInterval;

  return useRQuery(
    queryKey,
    queryFn,
    options
      ? {
          enabled: options.enabled,
          cacheTime: options.cacheTime,
          staleTime: options.staleTime,
          retry: options.retry,
          notifyOnChangeProps: options.notifyOnChangeProps,
          onSuccess: options.onSuccess,
          onError: options.onError,
          refetchOnWindowFocus: options.refetchOnWindowFocus,
          refetchInterval:
            typeof refetchInterval === "function"
              ? (data) => refetchInterval(data)
              : refetchInterval,
        }
      : options,
  );
}
